"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    feedbackPost: ()=>feedbackPost
});
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const FEEDBACK_URL = 'https://qaa.priceline.com/genai-svc/genai/chat/feedback';
const feedbackPost = async (args, url, headers)=>{
    const abortController = new AbortController();
    const timeoutId = setTimeout(()=>{
        abortController.abort();
    }, 30000);
    try {
        const res = await fetch(url || FEEDBACK_URL, {
            method: 'POST',
            body: JSON.stringify(args),
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                ...headers
            },
            signal: abortController.signal
        });
        clearTimeout(timeoutId);
        return await res.json();
    } catch (e) {
        const { cguid, conversationId, message, feedbackId } = args;
        analytics_js_default().log({
            message: 'Failed to submit Feedback',
            cguid,
            conversationId,
            content: message.content,
            vote: message.vote,
            feedbackId
        });
    }
};
exports.feedbackPost = __webpack_exports__.feedbackPost;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "feedbackPost"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
